(() => {
// ── 状態管理 ──────────────────────────────────────────
let $368e1c0ada6b6e01$var$rawData = []; // { date, close }
let $368e1c0ada6b6e01$var$closeData = []; // 終値の数値配列
let $368e1c0ada6b6e01$var$dataSource = 'yf';
let $368e1c0ada6b6e01$var$currentMode = 'lstm';
let $368e1c0ada6b6e01$var$chartMain = null, $368e1c0ada6b6e01$var$chartLoss = null, $368e1c0ada6b6e01$var$chartAe = null, $368e1c0ada6b6e01$var$chartError = null, $368e1c0ada6b6e01$var$chartCombined = null;
// 両モードの結果を保存（統合ビュー用）
let $368e1c0ada6b6e01$var$lstmResult = null; // { labels, actual, pred, futPad, allLabels }
let $368e1c0ada6b6e01$var$aeResult = null; // { labels, anomPoints, closeSlice }
// ── CPU バックエンド固定 ──────────────────────────────
(async ()=>{
    await tf.setBackend('cpu');
    await tf.ready();
    document.getElementById('backendBadge').textContent = 'BACKEND: CPU';
})();
// ── スライダー連動 ────────────────────────────────────
const $368e1c0ada6b6e01$var$r = document.getElementById('r_thresh');
const $368e1c0ada6b6e01$var$n = document.getElementById('n_thresh');
$368e1c0ada6b6e01$var$r.addEventListener('input', ()=>$368e1c0ada6b6e01$var$n.value = $368e1c0ada6b6e01$var$r.value);
$368e1c0ada6b6e01$var$n.addEventListener('input', ()=>{
    let v = Math.min(99, Math.max(80, parseInt($368e1c0ada6b6e01$var$n.value) || 95));
    $368e1c0ada6b6e01$var$r.value = v;
    $368e1c0ada6b6e01$var$n.value = v;
});
// ── ログ ─────────────────────────────────────────────
function $368e1c0ada6b6e01$var$log(msg, cls = '') {
    const box = document.getElementById('logBox');
    const s = document.createElement('span');
    if (cls) s.className = cls;
    s.innerHTML = msg + '<br>';
    box.appendChild(s);
    box.scrollTop = box.scrollHeight;
}
function $368e1c0ada6b6e01$var$clearLog() {
    document.getElementById('logBox').innerHTML = '';
}
// ── タブ切替 ──────────────────────────────────────────
function $368e1c0ada6b6e01$var$switchDs(t) {
    $368e1c0ada6b6e01$var$dataSource = t;
    [
        'yf',
        'csv',
        'syn'
    ].forEach((k)=>{
        document.getElementById('dsTab' + k.charAt(0).toUpperCase() + k.slice(1)).classList.toggle('active', k === t);
        document.getElementById('dsPanel' + k.charAt(0).toUpperCase() + k.slice(1)).classList.toggle('active', k === t);
    });
}
function $368e1c0ada6b6e01$var$switchMode(m) {
    $368e1c0ada6b6e01$var$currentMode = m;
    document.getElementById('modeTabLstm').className = 'mode-tab' + (m === 'lstm' ? ' active-lstm' : '');
    document.getElementById('modeTabAe').className = 'mode-tab' + (m === 'ae' ? ' active-ae' : '');
    document.getElementById('modePanelLstm').classList.toggle('active', m === 'lstm');
    document.getElementById('modePanelAe').classList.toggle('active', m === 'ae');
}
// ── プロキシ定義 ──────────────────────────────────────
function $368e1c0ada6b6e01$var$buildProxies(symbol, range) {
    // 自サーバープロキシ（最優先・CORS問題なし）
    const selfProxy = 'https://www.iseeit.jp/tools/yf-proxy.php' + `?symbol=${encodeURIComponent(symbol)}&range=${encodeURIComponent(range)}`;
    // 外部プロキシ（フォールバック）
    const yfUrl = `https://query1.finance.yahoo.com/v8/finance/chart/${encodeURIComponent(symbol)}` + `?interval=1d&range=${range}&events=history`;
    const enc = encodeURIComponent(yfUrl);
    return [
        {
            name: 'iseeit.jp proxy',
            url: selfProxy,
            parse: (r)=>r.json()
        },
        {
            name: 'corsproxy.io',
            url: `https://corsproxy.io/?${enc}`,
            parse: (r)=>r.json()
        },
        {
            name: 'allorigins.win',
            url: `https://allorigins.win/get?disableCache=true&url=${enc}`,
            parse: async (r)=>{
                const d = await r.json();
                return JSON.parse(d.contents);
            }
        }
    ];
}
function $368e1c0ada6b6e01$var$setPBadge(i, s) {
    const b = document.getElementById('pb' + i);
    if (b) b.className = 'pbadge ' + s;
}
// ── Yahoo Finance 取得 ────────────────────────────────
async function $368e1c0ada6b6e01$var$fetchYahoo() {
    const sym = document.getElementById('yfSymbol').value;
    const range = document.getElementById('yfRange').value;
    $368e1c0ada6b6e01$var$clearLog();
    $368e1c0ada6b6e01$var$resetResults();
    $368e1c0ada6b6e01$var$rawData = [];
    $368e1c0ada6b6e01$var$closeData = [];
    [
        0,
        1,
        2
    ].forEach((i)=>$368e1c0ada6b6e01$var$setPBadge(i, ''));
    const btn = document.getElementById('fetchBtn');
    btn.disabled = true;
    btn.textContent = "\u53D6\u5F97\u4E2D...";
    $368e1c0ada6b6e01$var$log(`<span class="info">[FETCH]</span> ${sym} (${range})`);
    const proxies = $368e1c0ada6b6e01$var$buildProxies(sym, range);
    let ok = false;
    for(let i = 0; i < proxies.length; i++){
        $368e1c0ada6b6e01$var$setPBadge(i, 'try');
        $368e1c0ada6b6e01$var$log(`<span class="info">[TRY]</span> ${proxies[i].name}`);
        try {
            const res = await Promise.race([
                fetch(proxies[i].url),
                new Promise((_, rej)=>setTimeout(()=>rej(new Error('timeout')), 8000))
            ]);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const json = await proxies[i].parse(res);
            const result = json?.chart?.result?.[0];
            if (!result) throw new Error("\u30C7\u30FC\u30BF\u306A\u3057");
            const ts = result.timestamp;
            const q = result.indicators?.quote?.[0];
            if (!ts || !q) throw new Error("quotes \u306A\u3057");
            $368e1c0ada6b6e01$var$rawData = ts.map((t, idx)=>({
                    date: new Date(t * 1000).toISOString().split('T')[0],
                    close: q.close?.[idx] ?? null
                })).filter((d)=>d.close !== null);
            $368e1c0ada6b6e01$var$closeData = $368e1c0ada6b6e01$var$rawData.map((d)=>d.close);
            $368e1c0ada6b6e01$var$setPBadge(i, 'ok');
            for(let j = i + 1; j < 3; j++)document.getElementById('pb' + j).className = 'pbadge';
            $368e1c0ada6b6e01$var$log(`<span class="ok">[OK]</span> ${$368e1c0ada6b6e01$var$rawData.length} \u{4EF6}\u{53D6}\u{5F97}`);
            ok = true;
            break;
        } catch (e) {
            $368e1c0ada6b6e01$var$log(`<span class="warn">[FAIL]</span> ${proxies[i].name}: ${e.message}`);
            $368e1c0ada6b6e01$var$setPBadge(i, 'fail');
        }
    }
    btn.disabled = false;
    btn.textContent = "\u25B6 \u30C7\u30FC\u30BF\u53D6\u5F97";
    if (!ok) {
        $368e1c0ada6b6e01$var$log('<span class="err">[ERROR]</span> \u3059\u3079\u3066\u306E\u30D7\u30ED\u30AD\u30B7\u3067\u5931\u6557\u3002\u5408\u6210\u30C7\u30FC\u30BF\u3078\u5207\u66FF\u3048\u307E\u3059...');
        $368e1c0ada6b6e01$var$generateSyntheticInternal(365, 8);
        $368e1c0ada6b6e01$var$switchDs('syn');
        return;
    }
    $368e1c0ada6b6e01$var$showFileInfo(sym, 'Yahoo Finance');
    $368e1c0ada6b6e01$var$enableRunButtons();
}
// ── CSV 読み込み ──────────────────────────────────────
document.getElementById('csvFile').addEventListener('change', function(e) {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev)=>$368e1c0ada6b6e01$var$parseCsv(ev.target.result, file.name);
    reader.readAsText(file, 'UTF-8');
});
const $368e1c0ada6b6e01$var$zone = document.getElementById('uploadZone');
$368e1c0ada6b6e01$var$zone.addEventListener('dragover', (e)=>{
    e.preventDefault();
    $368e1c0ada6b6e01$var$zone.classList.add('drag');
});
$368e1c0ada6b6e01$var$zone.addEventListener('dragleave', ()=>$368e1c0ada6b6e01$var$zone.classList.remove('drag'));
$368e1c0ada6b6e01$var$zone.addEventListener('drop', (e)=>{
    e.preventDefault();
    $368e1c0ada6b6e01$var$zone.classList.remove('drag');
    const f = e.dataTransfer.files[0];
    if (!f) return;
    const r = new FileReader();
    r.onload = (ev)=>$368e1c0ada6b6e01$var$parseCsv(ev.target.result, f.name);
    r.readAsText(f, 'UTF-8');
});
function $368e1c0ada6b6e01$var$parseCsv(text, name) {
    $368e1c0ada6b6e01$var$clearLog();
    $368e1c0ada6b6e01$var$resetResults();
    const lines = text.trim().split('\n').filter((l)=>l.trim());
    $368e1c0ada6b6e01$var$rawData = [];
    lines.forEach((line)=>{
        const cols = line.replace(/"/g, '').split(',');
        const date = cols[0]?.trim();
        const close = parseFloat(cols[1]);
        if (date && date.match(/\d{4}/) && !isNaN(close)) $368e1c0ada6b6e01$var$rawData.push({
            date: date,
            close: close
        });
    });
    // 昇順に統一
    const toTs = (s)=>new Date(s.replace(/\//g, '-')).getTime();
    const isDesc = $368e1c0ada6b6e01$var$rawData.length >= 2 && toTs($368e1c0ada6b6e01$var$rawData[0].date) > toTs($368e1c0ada6b6e01$var$rawData[$368e1c0ada6b6e01$var$rawData.length - 1].date);
    if (isDesc) $368e1c0ada6b6e01$var$rawData.reverse();
    $368e1c0ada6b6e01$var$closeData = $368e1c0ada6b6e01$var$rawData.map((d)=>d.close);
    if ($368e1c0ada6b6e01$var$closeData.length < 50) {
        $368e1c0ada6b6e01$var$log('<span class="err">[ERROR]</span> \u30C7\u30FC\u30BF\u304C\u5C11\u306A\u3059\u304E\u307E\u3059\uFF0850\u4EF6\u4EE5\u4E0A\u5FC5\u8981\uFF09');
        return;
    }
    $368e1c0ada6b6e01$var$log(`<span class="ok">[OK]</span> ${name}: ${$368e1c0ada6b6e01$var$rawData.length} \u{4EF6}`);
    $368e1c0ada6b6e01$var$showFileInfo(name, 'CSV');
    $368e1c0ada6b6e01$var$enableRunButtons();
}
// ── 合成データ生成 ────────────────────────────────────
function $368e1c0ada6b6e01$var$generateSynthetic() {
    const n = parseInt(document.getElementById('synPoints').value);
    const rate = parseInt(document.getElementById('synAnom').value);
    $368e1c0ada6b6e01$var$generateSyntheticInternal(n, rate);
}
function $368e1c0ada6b6e01$var$generateSyntheticInternal(n, anomRate) {
    $368e1c0ada6b6e01$var$clearLog();
    $368e1c0ada6b6e01$var$resetResults();
    $368e1c0ada6b6e01$var$rawData = [];
    $368e1c0ada6b6e01$var$closeData = [];
    let price = 145.0;
    const start = new Date('2024-01-04');
    let dc = 0;
    while($368e1c0ada6b6e01$var$rawData.length < n){
        const d = new Date(start);
        d.setDate(start.getDate() + dc++);
        if (d.getDay() === 0 || d.getDay() === 6) continue;
        const isAnom = Math.random() < anomRate / 100;
        const move = isAnom ? (Math.random() - 0.5) * 6 : (Math.random() - 0.49) * 0.8 + 0.01;
        price = Math.max(100, price + move);
        const yy = d.getFullYear(), mm = String(d.getMonth() + 1).padStart(2, '0'), dd = String(d.getDate()).padStart(2, '0');
        $368e1c0ada6b6e01$var$rawData.push({
            date: `${yy}/${mm}/${dd}`,
            close: +price.toFixed(3)
        });
    }
    $368e1c0ada6b6e01$var$closeData = $368e1c0ada6b6e01$var$rawData.map((d)=>d.close);
    $368e1c0ada6b6e01$var$log(`<span class="ok">[OK]</span> \u{5408}\u{6210}\u{30C7}\u{30FC}\u{30BF}\u{751F}\u{6210}: ${$368e1c0ada6b6e01$var$rawData.length} \u{4EF6}\u{FF08}\u{30A2}\u{30CE}\u{30DE}\u{30EA}\u{30FC}\u{7387} ${anomRate}%\u{FF09}`);
    $368e1c0ada6b6e01$var$showFileInfo("USD/JPY \u5408\u6210", "\u5408\u6210\u30C7\u30FC\u30BF");
    $368e1c0ada6b6e01$var$enableRunButtons();
}
// データ新規読み込み時に結果パネルをすべてリセット
function $368e1c0ada6b6e01$var$resetResults() {
    $368e1c0ada6b6e01$var$lstmResult = null;
    $368e1c0ada6b6e01$var$aeResult = null;
    document.getElementById('lstmResults').style.display = 'none';
    document.getElementById('aeResults').style.display = 'none';
    document.getElementById('combinedResults').style.display = 'none';
    [
        $368e1c0ada6b6e01$var$chartMain,
        $368e1c0ada6b6e01$var$chartLoss,
        $368e1c0ada6b6e01$var$chartAe,
        $368e1c0ada6b6e01$var$chartError,
        $368e1c0ada6b6e01$var$chartCombined
    ].forEach((c)=>{
        if (c) c.destroy();
    });
    $368e1c0ada6b6e01$var$chartMain = $368e1c0ada6b6e01$var$chartLoss = $368e1c0ada6b6e01$var$chartAe = $368e1c0ada6b6e01$var$chartError = $368e1c0ada6b6e01$var$chartCombined = null;
}
function $368e1c0ada6b6e01$var$showFileInfo(name, source) {
    const fi = document.getElementById('fileInfo');
    fi.classList.add('visible');
    document.getElementById('fi_count').textContent = $368e1c0ada6b6e01$var$rawData.length;
    document.getElementById('fi_period').textContent = `${$368e1c0ada6b6e01$var$rawData[0]?.date} \u{301C} ${$368e1c0ada6b6e01$var$rawData[$368e1c0ada6b6e01$var$rawData.length - 1]?.date}`;
    document.getElementById('fi_latest').textContent = $368e1c0ada6b6e01$var$closeData[$368e1c0ada6b6e01$var$closeData.length - 1]?.toFixed(3) ?? "\u2014";
    document.getElementById('fi_source').textContent = source;
}
function $368e1c0ada6b6e01$var$enableRunButtons() {
    document.getElementById('runLstmBtn').disabled = false;
    document.getElementById('runAeBtn').disabled = false;
}
// ── 正規化 ───────────────────────────────────────────
function $368e1c0ada6b6e01$var$normalize(arr) {
    const mn = Math.min(...arr), mx = Math.max(...arr), rng = mx - mn || 1;
    return {
        norm: arr.map((v)=>(v - mn) / rng),
        min: mn,
        max: mx,
        range: rng
    };
}
function $368e1c0ada6b6e01$var$denorm(v, min, range) {
    return v * range + min;
}
function $368e1c0ada6b6e01$var$makeSequences(normed, win) {
    const X = [], Y = [];
    for(let i = win; i < normed.length; i++){
        X.push(normed.slice(i - win, i).map((v)=>[
                v
            ]));
        Y.push(normed[i]);
    }
    return {
        X: X,
        Y: Y
    };
}
// ── LSTM 学習・予測 ───────────────────────────────────
async function $368e1c0ada6b6e01$var$runLstm() {
    if ($368e1c0ada6b6e01$var$closeData.length < 50) {
        $368e1c0ada6b6e01$var$log('<span class="err">[ERROR]</span> \u30C7\u30FC\u30BF\u3092\u5148\u306B\u8AAD\u307F\u8FBC\u3093\u3067\u304F\u3060\u3055\u3044');
        return;
    }
    $368e1c0ada6b6e01$var$clearLog();
    document.getElementById('lstmResults').style.display = 'none';
    const win = parseInt(document.getElementById('lstmWin').value);
    const steps = parseInt(document.getElementById('lstmSteps').value);
    const trainRatio = parseInt(document.getElementById('lstmTrainRatio').value) / 100;
    const epochs = 30;
    const batchSize = 16;
    const btn = document.getElementById('runLstmBtn');
    btn.disabled = true;
    document.getElementById('fetchBtn').disabled = true;
    document.getElementById('runBtnAe').disabled = true;
    document.getElementById('runAeBtn').disabled = true;
    $368e1c0ada6b6e01$var$log(`<span class="info">[LSTM]</span> win=${win} steps=${steps} trainRatio=${trainRatio * 100}%`);
    const { norm: norm, min: pMin, range: pRange } = $368e1c0ada6b6e01$var$normalize($368e1c0ada6b6e01$var$closeData);
    const { X: X, Y: Y } = $368e1c0ada6b6e01$var$makeSequences(norm, win);
    const trainSize = Math.floor(X.length * trainRatio);
    const xTrain = tf.tensor3d(X.slice(0, trainSize));
    const yTrain = tf.tensor2d(Y.slice(0, trainSize), [
        trainSize,
        1
    ]);
    const xTest = tf.tensor3d(X.slice(trainSize));
    // モデル構築
    const model = tf.sequential();
    model.add(tf.layers.lstm({
        units: 48,
        returnSequences: true,
        inputShape: [
            win,
            1
        ]
    }));
    model.add(tf.layers.dropout({
        rate: 0.2
    }));
    model.add(tf.layers.lstm({
        units: 24,
        returnSequences: false
    }));
    model.add(tf.layers.dropout({
        rate: 0.2
    }));
    model.add(tf.layers.dense({
        units: 1
    }));
    model.compile({
        optimizer: tf.train.adam(0.001),
        loss: 'meanSquaredError'
    });
    // プログレスバー
    const pw = document.getElementById('progressWrap');
    const pb = document.getElementById('progressBar');
    pw.style.display = 'block';
    pb.style.width = '0%';
    const lossHist = [];
    let bestLoss = Infinity;
    await model.fit(xTrain, yTrain, {
        epochs: epochs,
        batchSize: batchSize,
        callbacks: {
            onEpochEnd: async (epoch, logs)=>{
                const pct = Math.round((epoch + 1) / epochs * 100);
                pb.style.width = pct + '%';
                lossHist.push(logs.loss);
                if (logs.loss < bestLoss) bestLoss = logs.loss;
                if ((epoch + 1) % 5 === 0 || epoch === 0) $368e1c0ada6b6e01$var$log(`<span class="ok">[E${String(epoch + 1).padStart(2, '0')}]</span> loss: ${logs.loss.toFixed(6)}`);
                await tf.nextFrame();
            }
        }
    });
    $368e1c0ada6b6e01$var$log('<span class="ok">[DONE]</span> \u5B66\u7FD2\u5B8C\u4E86');
    // テスト予測
    const yPredNorm = Array.from(model.predict(xTest).dataSync());
    const yTestActual = Y.slice(trainSize).map((v)=>$368e1c0ada6b6e01$var$denorm(v, pMin, pRange));
    const yPredActual = yPredNorm.map((v)=>$368e1c0ada6b6e01$var$denorm(v, pMin, pRange));
    // RMSE・MAPE
    const rmse = Math.sqrt(yPredActual.reduce((s, v, i)=>s + (v - yTestActual[i]) ** 2, 0) / yPredActual.length);
    const mape = yPredActual.reduce((s, v, i)=>s + Math.abs((v - yTestActual[i]) / (yTestActual[i] || 1)), 0) / yPredActual.length * 100;
    // 複数ステップ予測
    let seq = norm.slice(norm.length - win).map((v)=>[
            v
        ]);
    const futPred = [];
    for(let s = 0; s < steps; s++){
        const t = tf.tensor3d([
            seq
        ]);
        const pv = model.predict(t).dataSync()[0];
        futPred.push($368e1c0ada6b6e01$var$denorm(pv, pMin, pRange));
        seq = [
            ...seq.slice(1),
            [
                pv
            ]
        ];
        t.dispose();
    }
    $368e1c0ada6b6e01$var$log(`<span class="ok">[RESULT]</span> RMSE: ${rmse.toFixed(3)}  MAPE: ${mape.toFixed(2)}%`);
    $368e1c0ada6b6e01$var$log(`<span class="ok">[PRED]</span>  \u{6B21}\u{306E}\u{5024}\u{4E88}\u{6E2C}: ${futPred[0].toFixed(3)}`);
    // ── 表示 ─────────────────────────────────────────
    document.getElementById('predBox').style.display = 'block';
    document.getElementById('predVal').textContent = futPred[0].toFixed(3);
    document.getElementById('predSub').textContent = `${steps}\u{30B9}\u{30C6}\u{30C3}\u{30D7}\u{5148}\u{306E}\u{6700}\u{7D42}\u{4E88}\u{6E2C}\u{FF1A}${futPred[futPred.length - 1].toFixed(3)}`;
    const sg = document.getElementById('lstmStats');
    sg.style.display = 'grid';
    document.getElementById('s_loss').textContent = bestLoss.toFixed(6);
    document.getElementById('s_rmse').textContent = rmse.toFixed(3);
    document.getElementById('s_mape').textContent = mape.toFixed(2) + '%';
    // メインチャート
    const testStartIdx = win + trainSize;
    const testLabels = $368e1c0ada6b6e01$var$rawData.slice(testStartIdx, testStartIdx + yTestActual.length).map((d)=>d.date);
    const futLabels = Array.from({
        length: steps
    }, (_, i)=>`+${i + 1}`);
    const allLabels = [
        ...testLabels,
        ...futLabels
    ];
    const actualPad = [
        ...yTestActual,
        ...Array(steps).fill(null)
    ];
    const predPad = [
        ...yPredActual,
        ...Array(steps).fill(null)
    ];
    const futPad = [
        ...Array(yTestActual.length - 1).fill(null),
        yTestActual[yTestActual.length - 1],
        ...futPred
    ];
    const chartDefs = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    color: '#4a5a72',
                    font: {
                        size: 11
                    },
                    boxWidth: 20
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#4a5a72',
                    font: {
                        size: 10
                    },
                    maxTicksLimit: 10
                },
                grid: {
                    color: '#f0f2f5'
                }
            },
            y: {
                ticks: {
                    color: '#4a5a72',
                    font: {
                        size: 10
                    }
                },
                grid: {
                    color: '#f0f2f5'
                }
            }
        }
    };
    if ($368e1c0ada6b6e01$var$chartMain) $368e1c0ada6b6e01$var$chartMain.destroy();
    $368e1c0ada6b6e01$var$chartMain = new Chart(document.getElementById('chartMain'), {
        type: 'line',
        data: {
            labels: allLabels,
            datasets: [
                {
                    label: "\u5B9F\u6E2C\u5024",
                    data: actualPad,
                    borderColor: '#8fa8cc',
                    borderWidth: 1.5,
                    pointRadius: 0,
                    tension: 0.2
                },
                {
                    label: "LSTM\u4E88\u6E2C\uFF08\u30C6\u30B9\u30C8\uFF09",
                    data: predPad,
                    borderColor: '#00d4ff',
                    borderWidth: 1.5,
                    borderDash: [
                        4,
                        3
                    ],
                    pointRadius: 0,
                    tension: 0.2
                },
                {
                    label: `\u{5C06}\u{6765}\u{4E88}\u{6E2C}\u{FF08}${steps}\u{30B9}\u{30C6}\u{30C3}\u{30D7}\u{FF09}`,
                    data: futPad,
                    borderColor: '#39ff14',
                    borderWidth: 2,
                    pointRadius: 4,
                    pointBackgroundColor: '#39ff14',
                    tension: 0.2,
                    spanGaps: false
                }
            ]
        },
        options: chartDefs
    });
    if ($368e1c0ada6b6e01$var$chartLoss) $368e1c0ada6b6e01$var$chartLoss.destroy();
    $368e1c0ada6b6e01$var$chartLoss = new Chart(document.getElementById('chartLoss'), {
        type: 'line',
        data: {
            labels: Array.from({
                length: lossHist.length
            }, (_, i)=>`E${i + 1}`),
            datasets: [
                {
                    label: "\u5B66\u7FD2\u66F2\u7DDA\uFF08Loss\uFF09",
                    data: lossHist,
                    borderColor: '#ff6b35',
                    borderWidth: 1.5,
                    pointRadius: 0,
                    tension: 0.3
                }
            ]
        },
        options: {
            ...chartDefs,
            plugins: {
                legend: {
                    labels: {
                        color: '#4a5a72',
                        font: {
                            size: 11
                        }
                    }
                }
            }
        }
    });
    // LSTM結果を保存（統合ビュー用）
    $368e1c0ada6b6e01$var$lstmResult = {
        allLabels: allLabels,
        actualPad: actualPad,
        predPad: predPad,
        futPad: futPad
    };
    document.getElementById('lstmResults').style.display = 'block';
    pw.style.display = 'none';
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            if ($368e1c0ada6b6e01$var$chartMain) $368e1c0ada6b6e01$var$chartMain.resize();
            if ($368e1c0ada6b6e01$var$chartLoss) $368e1c0ada6b6e01$var$chartLoss.resize();
            $368e1c0ada6b6e01$var$tryRenderCombined();
        });
    });
    xTrain.dispose();
    yTrain.dispose();
    xTest.dispose();
    model.dispose();
    btn.disabled = false;
    document.getElementById('fetchBtn').disabled = false;
    document.getElementById('runBtnAe').disabled = false;
    document.getElementById('runAeBtn').disabled = false;
}
// ── AutoEncoder 学習・検出 ────────────────────────────
async function $368e1c0ada6b6e01$var$runAe() {
    if ($368e1c0ada6b6e01$var$closeData.length < 50) {
        $368e1c0ada6b6e01$var$log('<span class="err">[ERROR]</span> \u30C7\u30FC\u30BF\u3092\u5148\u306B\u8AAD\u307F\u8FBC\u3093\u3067\u304F\u3060\u3055\u3044');
        return;
    }
    $368e1c0ada6b6e01$var$clearLog();
    document.getElementById('aeResults').style.display = 'none';
    const win = parseInt(document.getElementById('aeWin').value);
    const epochs = parseInt(document.getElementById('aeEpochs').value);
    const threshPct = parseInt(document.getElementById('n_thresh').value);
    const batch = 32;
    const btn = document.getElementById('runAeBtn');
    btn.disabled = true;
    document.getElementById('fetchBtn').disabled = true;
    document.getElementById('runBtnAe').disabled = true;
    document.getElementById('runLstmBtn').disabled = true;
    $368e1c0ada6b6e01$var$log(`<span class="info">[AE]</span> win=${win} epochs=${epochs} thresh=${threshPct}%tile`);
    const { norm: norm } = $368e1c0ada6b6e01$var$normalize($368e1c0ada6b6e01$var$closeData);
    // スライディングウィンドウ
    const windows = [];
    for(let i = win; i < norm.length; i++)windows.push(norm.slice(i - win, i));
    const xAll = tf.tensor2d(windows);
    const xTrain = tf.tensor2d(windows.slice(0, Math.floor(windows.length * 0.8)));
    // AutoEncoder 構築
    const model = tf.sequential();
    model.add(tf.layers.dense({
        inputShape: [
            win
        ],
        units: Math.max(4, Math.floor(win / 2)),
        activation: 'relu'
    }));
    model.add(tf.layers.dense({
        units: 4,
        activation: 'relu'
    }));
    model.add(tf.layers.dense({
        units: Math.max(4, Math.floor(win / 2)),
        activation: 'relu'
    }));
    model.add(tf.layers.dense({
        units: win,
        activation: 'sigmoid'
    }));
    model.compile({
        optimizer: 'adam',
        loss: 'meanSquaredError'
    });
    const pw = document.getElementById('progressWrap');
    const pb = document.getElementById('progressBar');
    pw.style.display = 'block';
    pb.style.width = '0%';
    await model.fit(xTrain, xTrain, {
        epochs: epochs,
        batchSize: batch,
        callbacks: {
            onEpochEnd: async (epoch, logs)=>{
                pb.style.width = Math.round((epoch + 1) / epochs * 100) + '%';
                if ((epoch + 1) % 10 === 0 || epoch === 0) $368e1c0ada6b6e01$var$log(`<span class="ok">[E${String(epoch + 1).padStart(2, '0')}]</span> loss: ${logs.loss.toFixed(6)}`);
                await tf.nextFrame();
            }
        }
    });
    $368e1c0ada6b6e01$var$log('<span class="ok">[DONE]</span> \u5B66\u7FD2\u5B8C\u4E86');
    // 再構成誤差
    const reconArr = Array.from(model.predict(xAll).dataSync());
    const inputArr = Array.from(xAll.dataSync());
    const errors = [];
    for(let i = 0; i < windows.length; i++){
        let mse = 0;
        for(let j = 0; j < win; j++)mse += (inputArr[i * win + j] - reconArr[i * win + j]) ** 2;
        errors.push(mse / win);
    }
    // 閾値（パーセンタイル）
    const sorted = [
        ...errors
    ].sort((a, b)=>a - b);
    const tIdx = Math.floor(sorted.length * threshPct / 100);
    const threshold = sorted[tIdx] ?? sorted[sorted.length - 1];
    const anomalies = errors.map((e)=>e > threshold);
    const anomCount = anomalies.filter(Boolean).length;
    const anomRate = (anomCount / errors.length * 100).toFixed(1);
    $368e1c0ada6b6e01$var$log(`<span class="ok">[RESULT]</span> \u{95BE}\u{5024}: ${threshold.toFixed(6)}  \u{30A2}\u{30CE}\u{30DE}\u{30EA}\u{30FC}: ${anomCount}\u{4EF6}\u{FF08}${anomRate}%\u{FF09}`);
    // ── 表示 ─────────────────────────────────────────
    document.getElementById('anomBox').style.display = 'block';
    document.getElementById('anomVal').textContent = anomCount + " \u4EF6";
    document.getElementById('anomSub').textContent = `\u{5168} ${errors.length} \u{70B9}\u{4E2D} ${anomRate}% \u{304C}\u{30A2}\u{30CE}\u{30DE}\u{30EA}\u{30FC}`;
    const as = document.getElementById('aeStats');
    as.style.display = 'grid';
    document.getElementById('ae_total').textContent = errors.length;
    document.getElementById('ae_anom').textContent = anomCount;
    document.getElementById('ae_rate').textContent = anomRate + '%';
    // ラベル（ウィンドウの終端日）
    const aeLabels = $368e1c0ada6b6e01$var$rawData.slice(win, win + errors.length).map((d)=>d.date);
    const closeSlice = $368e1c0ada6b6e01$var$closeData.slice(win, win + errors.length);
    // アノマリー点
    const anomPoints = closeSlice.map((v, i)=>anomalies[i] ? v : null);
    if ($368e1c0ada6b6e01$var$chartAe) $368e1c0ada6b6e01$var$chartAe.destroy();
    $368e1c0ada6b6e01$var$chartAe = new Chart(document.getElementById('chartAe'), {
        type: 'line',
        data: {
            labels: aeLabels,
            datasets: [
                {
                    label: "\u30EC\u30FC\u30C8",
                    data: closeSlice,
                    borderColor: '#8fa8cc',
                    borderWidth: 1.5,
                    pointRadius: 0,
                    tension: 0.2
                },
                {
                    label: "\u30A2\u30CE\u30DE\u30EA\u30FC\u691C\u51FA\u70B9",
                    data: anomPoints,
                    type: 'scatter',
                    pointBackgroundColor: 'rgba(255,68,68,0.85)',
                    pointRadius: 6,
                    pointStyle: 'triangle',
                    showLine: false
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'bottom',
                    labels: {
                        color: '#4a5a72',
                        font: {
                            size: 11
                        },
                        boxWidth: 20
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#4a5a72',
                        font: {
                            size: 10
                        },
                        maxTicksLimit: 10
                    },
                    grid: {
                        color: '#f0f2f5'
                    }
                },
                y: {
                    ticks: {
                        color: '#4a5a72',
                        font: {
                            size: 10
                        }
                    },
                    grid: {
                        color: '#f0f2f5'
                    }
                }
            }
        }
    });
    if ($368e1c0ada6b6e01$var$chartError) $368e1c0ada6b6e01$var$chartError.destroy();
    $368e1c0ada6b6e01$var$chartError = new Chart(document.getElementById('chartError'), {
        type: 'line',
        data: {
            labels: aeLabels,
            datasets: [
                {
                    label: "\u518D\u69CB\u6210\u8AA4\u5DEE",
                    data: errors,
                    borderColor: '#ff6b35',
                    borderWidth: 1,
                    pointRadius: 0,
                    tension: 0.2,
                    fill: {
                        target: 'origin',
                        above: 'rgba(255,107,53,0.08)'
                    }
                },
                {
                    label: "\u95BE\u5024",
                    data: Array(errors.length).fill(threshold),
                    borderColor: '#ff4444',
                    borderWidth: 1.5,
                    borderDash: [
                        6,
                        4
                    ],
                    pointRadius: 0
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'bottom',
                    labels: {
                        color: '#4a5a72',
                        font: {
                            size: 11
                        },
                        boxWidth: 20
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#4a5a72',
                        font: {
                            size: 10
                        },
                        maxTicksLimit: 10
                    },
                    grid: {
                        color: '#f0f2f5'
                    }
                },
                y: {
                    ticks: {
                        color: '#4a5a72',
                        font: {
                            size: 10
                        }
                    },
                    grid: {
                        color: '#f0f2f5'
                    }
                }
            }
        }
    });
    // AE結果を保存（統合ビュー用）
    $368e1c0ada6b6e01$var$aeResult = {
        aeLabels: aeLabels,
        closeSlice: closeSlice,
        anomPoints: anomPoints
    };
    document.getElementById('aeResults').style.display = 'block';
    pw.style.display = 'none';
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            if ($368e1c0ada6b6e01$var$chartAe) $368e1c0ada6b6e01$var$chartAe.resize();
            if ($368e1c0ada6b6e01$var$chartError) $368e1c0ada6b6e01$var$chartError.resize();
            $368e1c0ada6b6e01$var$tryRenderCombined();
        });
    });
    xAll.dispose();
    xTrain.dispose();
    model.dispose();
    btn.disabled = false;
    document.getElementById('fetchBtn').disabled = false;
    document.getElementById('runBtnAe').disabled = false;
    document.getElementById('runLstmBtn').disabled = false;
}
// ── 統合ビュー描画 ────────────────────────────────────
function $368e1c0ada6b6e01$var$tryRenderCombined() {
    if (!$368e1c0ada6b6e01$var$lstmResult || !$368e1c0ada6b6e01$var$aeResult) return; // 両方揃っていなければ何もしない
    const { allLabels: allLabels, actualPad: actualPad, predPad: predPad, futPad: futPad } = $368e1c0ada6b6e01$var$lstmResult;
    const { aeLabels: aeLabels, closeSlice: closeSlice, anomPoints: anomPoints } = $368e1c0ada6b6e01$var$aeResult;
    // LSTMのラベルとAEのラベルを統合（union）して時系列順に並べる
    // 共通ラベルセットを作り、AEアノマリー点をLSTMラベル空間にマッピング
    // 簡易実装：aeLabelsのアノマリー点をallLabelsに対応付ける
    const anomSet = new Set();
    aeLabels.forEach((label, i)=>{
        if (anomPoints[i] !== null) anomSet.add(label);
    });
    // LSTM allLabels 空間でアノマリーポイントを構築
    const combinedAnom = allLabels.map((label, i)=>{
        if (!anomSet.has(label)) return null;
        // 実測値またはpredPadの値を使用
        return actualPad[i] ?? predPad[i] ?? null;
    });
    if ($368e1c0ada6b6e01$var$chartCombined) $368e1c0ada6b6e01$var$chartCombined.destroy();
    $368e1c0ada6b6e01$var$chartCombined = new Chart(document.getElementById('chartCombined'), {
        type: 'line',
        data: {
            labels: allLabels,
            datasets: [
                {
                    label: "\u5B9F\u6E2C\u5024",
                    data: actualPad,
                    borderColor: '#8fa8cc',
                    borderWidth: 1.5,
                    pointRadius: 0,
                    tension: 0.2
                },
                {
                    label: "LSTM \u4E88\u6E2C",
                    data: predPad,
                    borderColor: '#00d4ff',
                    borderWidth: 1.5,
                    borderDash: [
                        4,
                        3
                    ],
                    pointRadius: 0,
                    tension: 0.2
                },
                {
                    label: "\u5C06\u6765\u4E88\u6E2C",
                    data: futPad,
                    borderColor: '#39ff14',
                    borderWidth: 2,
                    pointRadius: 3,
                    pointBackgroundColor: '#39ff14',
                    tension: 0.2,
                    spanGaps: false
                },
                {
                    label: "\u30A2\u30CE\u30DE\u30EA\u30FC\u691C\u51FA\u70B9",
                    data: combinedAnom,
                    type: 'scatter',
                    pointBackgroundColor: 'rgba(255,68,68,0.85)',
                    pointRadius: 7,
                    pointStyle: 'triangle',
                    showLine: false
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'bottom',
                    labels: {
                        color: '#4a5a72',
                        font: {
                            size: 11
                        },
                        boxWidth: 20
                    }
                },
                tooltip: {
                    callbacks: {
                        label: (ctx)=>` ${ctx.dataset.label}: ${ctx.parsed.y?.toFixed(3) ?? ''}`
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#4a5a72',
                        font: {
                            size: 10
                        },
                        maxTicksLimit: 10
                    },
                    grid: {
                        color: '#f0f2f5'
                    }
                },
                y: {
                    ticks: {
                        color: '#4a5a72',
                        font: {
                            size: 10
                        }
                    },
                    grid: {
                        color: '#f0f2f5'
                    }
                }
            }
        }
    });
    document.getElementById('combinedResults').style.display = 'block';
    // スマホ対策resize
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            if ($368e1c0ada6b6e01$var$chartCombined) $368e1c0ada6b6e01$var$chartCombined.resize();
        });
    });
    $368e1c0ada6b6e01$var$log('<span class="ok">[COMBINED]</span> \u7D71\u5408\u30D3\u30E5\u30FC\u3092\u66F4\u65B0\u3057\u307E\u3057\u305F');
}
document.getElementById("dsTabYf").addEventListener("click", ()=>{
    $368e1c0ada6b6e01$var$switchDs('yf');
});
document.getElementById("dsTabCsv").addEventListener("click", ()=>{
    $368e1c0ada6b6e01$var$switchDs('csv');
});
document.getElementById("dsTabSyn").addEventListener("click", ()=>{
    $368e1c0ada6b6e01$var$switchDs('syn');
});
document.getElementById("fetchBtn").addEventListener("click", $368e1c0ada6b6e01$var$fetchYahoo);
document.getElementById("runBtnAe").addEventListener("click", $368e1c0ada6b6e01$var$generateSynthetic);
document.getElementById("modeTabLstm").addEventListener("click", ()=>{
    $368e1c0ada6b6e01$var$switchMode('lstm');
});
document.getElementById("modeTabAe").addEventListener("click", ()=>{
    $368e1c0ada6b6e01$var$switchMode('ae');
});
document.getElementById("runLstmBtn").addEventListener("click", $368e1c0ada6b6e01$var$runLstm);
document.getElementById("runAeBtn").addEventListener("click", $368e1c0ada6b6e01$var$runAe);

})();
//# sourceMappingURL=fx-lstm-anomaly.js.map
